import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <SmoothScroll>
      <div className="grain-overlay" />
      <Nav />
      <main data-testid="home-landing">
        <Hero />
      </main>
      <Footer />
    </SmoothScroll>
  );
}
